import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ArticleCard from "./ArticleCard";
import { formatDate } from "../../utils/helps";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import ConfirmModal from "../ConfirmModal.js";

export default function NewsLayout({ data }) {
  // const { adsVip, adsNormal } = data || {};

  const posts = useSelector((state) =>
    state.posts?.posts
      ?.filter(
        (post) =>
          post.status === "published" &&
          post.slug !== "gioi-thieu" &&
          post.slug !== "dieu-khoan",
      )
      ?.filter((e) => e.type !== "notification"),
  );

  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [cartChange, setCartChange] = useState([]);

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  const handleSearch = () => {
    if (keyword != "") {
      navigate("/danh-sach-san-pham?s=" + keyword);
    } else {
      navigate("/danh-sach-san-pham");
    }
  };

  // const handleOpenModal = (cart) => {
  //   setCartChange((prev) => [...prev, cart]);
  //   setIsOpenModal(true);
  // };

  const handleSubmitCart = () => {
    localStorage.setItem("cart", JSON.stringify(cartChange));
    setCartChange([]);
    handleCloseModal();
    navigate("/gio-hang");
  };

  const handleDetail = (product) => {
    if (product.madeBy === "KATEC") {
      navigate("/san-pham/" + product.slug);
    } else {
      window.open(product.companyURL || "#", "_blank");
    }
  };

  return (
    <div className="container mx-auto pt-2">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        {/* Main Content */}
        <div className="lg:col-span-8">
          {/* Featured Article */}
          <div className="card shadow-xl rounded-lg overflow-hidden mb-4">
            <div className="grid grid-cols-1 lg:grid-cols-8 gap-2">
              {/* Main Article */}
              <div className="col-span-5">
                <figure className="aspect-[3/2] border border-gray-300 rounded-lg overflow-hidden">
                  <img
                    src={`${process.env.REACT_APP_API_URL}media/${posts[0]?.images[0]?.url}`}
                    alt={posts[0]?.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </figure>
                <div className="card-body p-[8px]">
                  <Link to={`/post/${posts[0]?.slug}`}>
                    <h2
                      className="card-title text-[21px] font-semibold text-ellipsis overflow-hidden text-justify"
                      style={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,
                      }}
                    >
                      {posts[0]?.title}
                    </h2>
                  </Link>

                  <p className="text-sm text-gray-500 mb-2 italic">
                    {formatDate(posts[0]?.updatedAt)}
                  </p>
                  <p className="text-gray-700">{posts[0]?.description}</p>
                </div>
              </div>

              {/* Side Articles */}
              <div className="col-span-3 ml-6 pr-2">
                <ul className="list-disc list-outside">
                  {posts?.slice(0, 4)?.map((article) => (
                    <li className="ms-0 px-0" key={article.id}>
                      <Link
                        to={`/post/${article.slug}`}
                        className="block py-3 border-b last:border-none hover:bg-base-200 transition-colors text-justify pr-3"
                      >
                        <h3 className="text-sm font-semibold">
                          {article.title}
                        </h3>
                        <p className="text-sm text-gray-500 italic">
                          {/* {article.date} */}
                          {formatDate(article.updatedAt)}
                        </p>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 bg-base-100">
            {posts?.slice(1, 4)?.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>

        <div className="lg:col-span-4 space-y-4 h-full flex flex-col justify-start">
          <h2 className="text-xl font-semibold">Sản phẩm của hội viên</h2>
          <div>
            <div className="flex items-center w-full max-w-md border border-gray-300 rounded-lg overflow-hidden">
              <input
                type="text"
                placeholder="Tìm kiếm sản phẩm hội viên"
                className="w-full p-3 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
              />
              <button
                className="p-3 hover:bg-gray-200 transition"
                onClick={handleSearch}
              >
                <MagnifyingGlassIcon className="w-5 h-5 text-gray-600" />
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-2 p-2  rounded-2xl shadow-lg">
              {data?.slice(0, 4).map((banner, index) => (
                <div
                  key={index}
                  className="w-full cursor-pointer"
                  onClick={() => handleDetail(banner)}
                >
                  <div className="max-w-sm aspect-[4/4] rounded-md overflow-hidden shadow-lg border border-gray-300">
                    <img
                      src={banner.urlImage}
                      alt={banner.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-4 mt-2 p-2 rounded-2xl shadow-lg">
              {data?.slice(4, 8).map((banner, index) => (
                <div
                  key={index}
                  className="w-full cursor-pointer"
                  onClick={() => handleDetail(banner)}
                >
                  <div className="max-w-sm aspect-[5/4] rounded-md overflow-hidden shadow-lg border border-gray-300">
                    <img
                      src={banner.urlImage}
                      alt={banner.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-4 mt-2">
              {data?.slice(8, 9).map((banner, index) => (
                <div
                  key={index}
                  className="w-full cursor-pointer"
                  onClick={() => handleDetail(banner)}
                >
                  <div className="max-w-sm rounded-md overflow-hidden shadow-lg p-3 border border-gray-300">
                    <img
                      src={banner.urlImage}
                      alt={banner.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
              {data?.slice(9, 10).map((banner, index) => (
                <div
                  key={index}
                  className="w-full cursor-pointer"
                  onClick={() => handleDetail(banner)}
                >
                  <div className="max-w-sm rounded-md overflow-hidden shadow-lg p-3 border border-gray-300">
                    <img
                      src={banner.urlImage}
                      alt={banner.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex items-center justify-center">
            <Link
              to={"/danh-sach-san-pham"}
              className="min-h-12 hover:bg-base-300 
              btn btn-sm btn-warning
              px-4 text-sm font-semibold rounded-lg shadow-md hover:bg-base-600 focus:outline-none focus:ring-2 focus:ring-base-400"
            >
              Xem thêm sản phẩm
            </Link>
          </div>
        </div>
      </div>

      <ConfirmModal
        isOpen={isOpenModal}
        onClose={handleCloseModal}
        onSubmit={handleSubmitCart}
        message={
          "Bạn chỉ có thể thêm sản phẩm từ cùng một công ty. \n Bạn có muốn xoá sản phẩm trong giỏ hàng không?"
        }
      />
    </div>
  );
}
